import { AdminService } from "@/common/api.service";
import {
  FETCH_ADMIN_INFO_DOC_LIST,
  FETCH_ADMIN_LIST,
  FETCH_ADMIN_STATUS_DOCS_LIST
} from "./actions.type";
import {
  FETCH_ADMIN_INFO_DOC_LIST_END,
  FETCH_ADMIN_INFO_DOC_LIST_START,
  FETCH_ADMIN_LIST_END,
  FETCH_ADMIN_LIST_START,
  FETCH_ADMIN_STATUS_DOCS_LIST_END,
  FETCH_ADMIN_STATUS_DOCS_LIST_START
} from "@/store/mutations.type";

const state = {
  adminList: {
    items: []
  },
  adminStatusDocsItems: [],
  allGroupUserList: {},
  programList: [],
  managerList: [],
  commentListByType: [],
  statusAcceptancesProgramList: [],
  statusLoadProgramList: [],
  isAdminLoading: false,
  isAdminStatusDocsLoading: false,
  isAdminInfoDocLoading: false,
  adminInfoDocItem: {},
  commentsList: {},
  allListValueTemplates: [],
  allTypeList: {},
  allTypeListDz: {},
  allVidDocDZ: [],
  allExtList: [],
  listFolderES: [],
};

const getters = {
  adminList() {
    return state.adminList;
  },
  adminStatusDocsItems() {
    return state.adminStatusDocsItems;
  },
  allGroupUserList() {
    return state.allGroupUserList;
  },
  programList() {
    return state.programList;
  },
  managerList() {
    return state.managerList;
  },
  commentListByType() {
    return state.commentListByType;
  },
  statusAcceptancesProgramList() {
    return state.statusAcceptancesProgramList;
  },
  statusLoadProgramList() {
    return state.statusLoadProgramList;
  },
  isAdminStatusDocsLoading() {
    return state.isAdminStatusDocsLoading;
  },
  adminInfoDocItem() {
    return state.adminInfoDocItem;
  },
  commentsList() {
    return state.commentsList;
  },
  allListValueTemplates() {
    return state.allListValueTemplates;
  },
  allTypeList() {
    return state.allTypeList;
  },
  allTypeListDz() {
    return state.allTypeListDz;
  },
  allVidDocDZ() {
    return state.allVidDocDZ;
  },
  allExtList() {
    return state.allExtList;
  },
  listFolderES() {
    return state.listFolderES;
  },
  isAdminInfoDocLoading() {
    return state.isAdminInfoDocLoading;
  }
};

const actions = {
  async [FETCH_ADMIN_LIST]({ commit }, params) {
    commit(FETCH_ADMIN_LIST_START);
    return AdminService.getListRequests(params)
      .then(({ data }) => {
        commit(FETCH_ADMIN_LIST_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_ADMIN_STATUS_DOCS_LIST]({ commit }, params) {
    commit(FETCH_ADMIN_STATUS_DOCS_LIST_START);
    return AdminService.getListStatusLoadDocuments(params)
      .then(({ data }) => {
        commit(FETCH_ADMIN_STATUS_DOCS_LIST_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_ADMIN_INFO_DOC_LIST]({ commit }, id) {
    commit(FETCH_ADMIN_INFO_DOC_LIST_START);
    return AdminService.getInfoDocument(id)
      .then(({ data }) => {
        commit(FETCH_ADMIN_INFO_DOC_LIST_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_ADMIN_LIST_START](state) {
    state.isAdminLoading = true;
  },
  [FETCH_ADMIN_STATUS_DOCS_LIST_START](state) {
    state.isAdminStatusDocsLoading = true;
  },
  [FETCH_ADMIN_INFO_DOC_LIST_START](state) {
    state.isAdminInfoDocLoading = true;
  },
  [FETCH_ADMIN_LIST_END](state, list) {
    state.adminList = list;
    state.isAdminLoading = false;
  },
  [FETCH_ADMIN_STATUS_DOCS_LIST_END](state, data) {
    state.adminStatusDocsItems = data.items;
    state.allGroupUserList = data.allGroupUserList;
    state.programList = data.programList;
    state.managerList = data.managerList;
    state.allVidDocDZ = data.allVidDocDZ;
    state.allTypeList = data.allTypeList;
    state.allTypeListDz = data.allTypeListDz;
    state.listFolderES = data.listFolderES;
    state.allExtList = data.allExtList;
    state.commentListByType = data.commentListByType;
    state.statusAcceptancesProgramList = data.statusAcceptancesProgramList;
    state.statusLoadProgramList = data.statusLoadProgramList;
    state.isAdminStatusDocsLoading = false;
  },
  [FETCH_ADMIN_INFO_DOC_LIST_END](state, data) {
    state.adminInfoDocItem = data.item;
    state.allGroupUserList = data.allGroupUserList;
    state.allListValueTemplates = data.allListValueTemplates;
    state.allTypeList = data.allTypeList;
    state.allVidDocDZ = data.allVidDocDZ;
    state.allExtList = data.allExtList;
    state.programList = data.programList;
    state.managerList = data.managerList;
    state.commentListByType = data.commentListByType;
    state.commentsList = data.commentsList;
    state.statusAcceptancesProgramList = data.statusAcceptancesProgramList;
    state.statusLoadProgramList = data.statusLoadProgramList;
    state.isAdminInfoDocLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
